var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{staticClass:"mx-auto center-block",attrs:{"autoplay":false,"interval":8000,"data":_vm.slides,"controls":false,"slide-on-swipe":true,"indicator-type":"disc"}})}
var staticRenderFns = []

export { render, staticRenderFns }